// An error class for invalid echo responses. This is intended to add more
// visibility to errors reported to bug snag.
export class EchoError extends Error {
  constructor(message: string, headers: string) {
    super(`${message}\n${headers}`)
    this.name = 'EchoError'
  }
}

export class FetchEchoError extends Error {
  constructor(message: string, response: Response) {
    super(`${message}\n${JSON.stringify(Object.fromEntries(response.headers.entries()))}`)
    this.name = 'EchoError'
  }
}
